<template>
    <span class="button-popup">

        <!-- DEVIS -->
        <v-dialog v-if="type === 'devis'" v-model="dialog" max-width="800">
        <template v-slot:activator="{ on, attrs }">
            <v-btn class="mt-4 mx-4 primary-button" v-bind="attrs" v-on="on">{{buttontext}}</v-btn>
        </template>
        <v-card>
            <v-img src="/images/devis.png"></v-img>
            <v-card-actions class="d-flex justify-space-around">
                <div class="mt-4 mb-8">
                    <v-btn class="mt-4 mx-4 primary-button" text @click="dialog = false">Accepter</v-btn>
                    <v-btn class="mt-4 mx-4 primary-button outlined" text @click="dialog = false">Refuser</v-btn>
                </div>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <!-- EVALUATION -->
        <v-dialog v-if="type === 'evaluation'" v-model="dialog" max-width="800">
            <template v-slot:activator="{ on, attrs }">
                <v-btn class="mt-4 mx-4 primary-button" v-bind="attrs" v-on="on">{{buttontext}}</v-btn>
            </template>
            <v-card>
                <v-btn icon @click="dialog = false" class="close-icon">
                    <v-icon class="black_">mdi-close</v-icon>
                </v-btn>
                <div class="dialog-content">
                    <v-card-title>Nom Prénom Locataire</v-card-title>
                    <v-card-title>Nom Prestataire</v-card-title>
                    <v-card-text class="pt-8 grey_">Date</v-card-text>
                    <v-card-text>
                        <p class="mb-4 black_">Qualité de la prestation</p>
                        <v-rating :value="4.5" color="primary" dense half-increments readonly size="14" class="mb-4"></v-rating>
                        <p class="mb-4 black_">Qualité de la prestation</p>
                        <v-rating :value="4.5" color="primary" dense half-increments readonly size="14" class="mb-4"></v-rating>
                        <p class="mb-4 black_">Commentaire</p>
                        <p class="grey_">Verum ad istam omnem orationem brevis est defensio. Nam quoad aetas M. Caeli dare potuit isti suspicioni locum, fuit primum ipsius pudore, deinde etiam patris diligentia disciplinaque munita. Qui ut huic virilem togam deditšnihil dicam hoc loco de me; tantum sit</p>
                    </v-card-text>
                </div>
            </v-card>
        </v-dialog>

        <!-- SPONSORING -->
        <v-dialog v-if="type === 'sponsoring'" v-model="dialog" max-width="1200">
            <template v-slot:activator="{ on, attrs }">
                <v-btn class="mt-4 mx-4 primary-button" v-bind="attrs" v-on="on">{{buttontext}}</v-btn>
            </template>
            <v-card class="data-table popup">
                <v-btn icon @click="dialog = false" class="close-icon">
                    <v-icon class="black_">mdi-close</v-icon>
                </v-btn>
                <div class="dialog-content">
                    <v-card-title class="text-uppercase my-4">Le locataire</v-card-title>
                    <v-data-table
                        :headers="headerstenant"
                        :items="tenant"
                        hide-default-footer
                        class="elevation-1"
                    ></v-data-table>
                    <v-card-title class="text-uppercase my-4">vous propose</v-card-title>
                    <v-data-table
                        :headers="headerssponsoring"
                        :items="sponsoring"
                        hide-default-footer
                        class="elevation-1"
                    ></v-data-table>
                    <v-card-title class="text-uppercase my-4">pour le logement</v-card-title>
                    <v-data-table
                        :headers="headersapartment"
                        :items="apartment"
                        hide-default-footer
                        class="elevation-1"
                    ></v-data-table>
                    <v-card-title class="text-uppercase my-4">à date du <span class="primary_"> 12/06/2022</span></v-card-title>
                    <v-card-actions class="d-flex justify-space-around">
                        <div class="mt-4 mb-8">
                            <v-btn class="mt-4 mx-4 primary-button" text @click="accept(true); dialog = false">Contacter</v-btn>
                            <v-btn class="mt-4 mx-4 primary-button outlined" text @click="accept(false); dialog = false">Refuser</v-btn>
                        </div>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </span>
</template>

<style lang="scss">
    .v-dialog{
        border-radius: 15px;
        .v-card{
            padding: 1rem;
            .close-icon{
                float: right;
            }
            .dialog-content{
                padding: 2rem 0;
                .v-card__title{
                    padding-top: 0;
                    padding-bottom: 0;
                    line-height: 1.5;
                    span{
                        font-size: 1.25rem !important;
                    }
                }
                .v-rating .v-icon{
                    font-size: 1.5rem !important;
                }
            }
        }
    }
</style>

<script>
    import axios from 'axios'
    import { apiURL } from '@/../config'
    export default {
    name: 'ButtonPopup',
    props: ['type', 'buttontext'],
    data: () => {
        return {
            dialog: false,
            sponsorship: {
                activate: '',
                userId: ''
            },
            headerstenant: [
                { text: 'Nom', value: 'name' },
                { text: 'Prénom', value: 'surname' },
                { text: 'Adresse', value: 'address' },
                { text: 'Email', value: 'email' },
                { text: 'Début de bail', value: 'leasebeginning' },
                { text: 'Fin de bail', value: 'leaseending' },
                { text: 'Points', value: 'points' }
            ],
            tenant: [
                {
                    name: 'Dupont',
                    surname: 'Jean',
                    address: 'rue du moulin - 06000 Nice',
                    email: 'jeandupont@mail.fr',
                    leasebeginning: '12/12/2019',
                    leaseending: '12/12/2022',
                    points: '222'
                }
            ],
            headerssponsoring: [
                { text: 'Nom', value: 'name' },
                { text: 'Prénom', value: 'surname' },
                { text: 'Email', value: 'email' }
            ],
            sponsoring: [
                {
                    name: 'Dupont',
                    surname: 'Jean',
                    email: 'jeandupont@mail.fr'
                }
            ],
            headersapartment: [
                { text: 'Résidence', value: 'residence' },
                { text: 'Bâtiment', value: 'building' },
                { text: 'Appartement', value: 'apartment' }
            ],
            apartment: [
                {
                    residence: 'Bon Accueil',
                    building: 'C',
                    apartment: '26'
                }
            ]
        }
    },
    async created () {
        try {
            // TENANT REQUEST
            const RequestRes = await axios.get(`${apiURL}/data/tenant/sponsorship/last/:id`)
            console.log(RequestRes)
            this.request = RequestRes.data
        } catch (e) {
            alert('Une erreur est survenue, veuillez réessayer.')
            console.log(e)
        }
    },
    methods: {
        // RESPONSE TO SPONSORING REQUEST
        async accept (isAccepted) {
            this.$store.dispatch('loading')
            try {
                this.sponsorship.activate = isAccepted
                await axios.post(`${apiURL}/manage/candidate/account`, this.sponsorship)
                this.$router.push('/locataires')
            } catch (e) {
                alert('Une erreur est survenue, veuillez réessayer.')
                console.log(e)
            } finally {
                this.$store.dispatch('stop_loading')
            }
        }
    }
}
</script>